<template>
    <div class="download-center-wrapper">
      <app-header></app-header>
      <div class="download-center-content">
        <app-aside :linksArray="links"></app-aside>
        <div class="download-center-content-main">
          <app-catalogues v-if="this.$route.params.page == 'catalogues'"></app-catalogues>
          <app-certificates v-if="this.$route.params.page == 'certificates'"></app-certificates>
          <!-- <app-reports v-if="this.$route.params.page == 'reports'"></app-reports> -->
          <app-dpresentations v-if="this.$route.params.page == 'dpresentations'"></app-dpresentations>
          <app-generalterms v-if="this.$route.params.page == 'generalterms'"></app-generalterms>
        </div>
      </div>
    </div>
</template>

<script>
import Header from "./download-center/Header";
import Aside from "./shared/Aside";
import Catalogues from "./download-center/Catalogues";
import Certificates from "./download-center/Certificates";
//import Reports from "./download-center/Reports";
import Dpresentations from "./download-center/Dpresentations";
import Generalterms from "./download-center/Generalterms";

export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appCatalogues: Catalogues,
    appCertificates: Certificates,
    //appReports: Reports,
    appDpresentations: Dpresentations,
    appGeneralterms: Generalterms
  },
  data() {
    return {
      links: [
        { name: "Каталози", url: "/download-center/catalogues" },
        { name: "Сертификати", url: "/download-center/certificates" },
       // { name: "Отчети", url: "/download-center/reports" },
        { name: "Презентации", url: "/download-center/dpresentations" },
        { name: "Общи условия", url: "/download-center/generalterms" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //      this.isPageExisting();
    }
  },
  methods: {
    isPageExisting() {
      switch (this.$route.params.page) {
        case "catalogues":
          break;
        default:
          this.$router.replace("../404");
      }
    }
  },
  mounted() {
    //    this.isPageExisting();
  }
};
</script>

<style scoped>
.download-center-content {
  display: flex;
}
.download-center-content-main {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .download-center-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadCenter.vue